import styled from 'styled-components';
import { device, hexToRGB } from '@/styles/helpers';

export const ScVipTransfer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  max-width: 420px;

  & .transfer-wrapper {
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;

    & .title {
      font-weight: 700;
      text-transform: uppercase;
      & .step {
        color: ${({ theme }) => theme.yellowColor};
      }
    }

    & .description {
      text-align: start;
      color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.6)};
    }
  }

  @media (${device.mobileS}) {
    max-width: none;
    & .transfer-wrapper {
      align-items: center;
      & .description {
        text-align: center;
      }
    }
  }

  @media (${device.mobile}) {
    max-width: none;
    & .transfer-wrapper {
      align-items: left;
      & .description {
        text-align: left;
      }
    }
  }
`;
